import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import cubaimg from "../../assets/logos/small-logo.png";
import CustomizerContext from '../../_helper/Customizer';

const SidebarIcon = () => {
  const { layoutURL } = useContext(CustomizerContext);
  return (
    <div className="logo-icon-wrapper">
      <Link to={`/administrator`}>
        <img
          className="img-fluid"
          src={cubaimg}
          alt="Logo"
          style={{ maxWidth: "40px", height: "40px" }}
        />

      </Link>
    </div>
  );
};

export default SidebarIcon;